/**
 * CM > IPS > 침입탐지 프로파일 > 발신 기반 세션 제어
 *
 * @since 2021-09-09
 * @author wj_tams_dev04
 */
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

export const state = () => ({
  srcBaseSessionList: [],
  orgSrcBaseSessionList: []
})

export const mutations = {
  initStore (state) {
    state.srcBaseSessionList = []
    state.orgSrcBaseSessionList = []
  },
  /**
   * 발신기반 세션 제어 정책을 추가한다.
   */
  addSrcBaseSession (state, policy) {
    state.srcBaseSessionList.push(_.cloneDeep(policy))
  },
  /**
   * 발신 기반 세션 제어 정책을 수정한다. 단일 수정일때만 호출된다.
   */
  setSrcBaseSession (state, policy) {
    const idx = state.srcBaseSessionList.findIndex(({src_sess_ctrl_policy_id: id}) => id === policy.src_sess_ctrl_policy_id)

    if (idx > -1) {
      const copy = _.cloneDeep(state.srcBaseSessionList)
      copy[idx] = policy

      state.srcBaseSessionList = copy
    }
  },
  /**
   * 발신 기반 세션 제어 정책을 수정한다.
   */
  setSrcBaseSessions (state, rules) {
    const copy = _.cloneDeep(state.srcBaseSessionList)
    _.forEach(rules, (policy) => {
      const idx = state.srcBaseSessionList.findIndex(({src_sess_ctrl_policy_id: id}) => id === policy.ngips_ddos_id)
      if (idx > -1) copy[idx] = policy
    })
    state.srcBaseSessionList = Object.freeze(copy)
  },
  /**
   * 발신기반 세션 제어 정책 목록을 스토어에 저장한다.
   */
  initSrcBaseSessionList (state, policyList) {
    state.srcBaseSessionList = policyList
    state.orgSrcBaseSessionList = _.cloneDeep(policyList)
  },
  /**
   * 원본 데이터를 갱신한다.
   */
  setSrcBaseSessionList (state, policyList) {
    state.srcBaseSessionList = Object.freeze(_.cloneDeep(policyList))
  },
  /**
   * 원본 데이터를 갱신한다.
   */
  copySrcBaseSessionList (state) {
    state.orgSrcBaseSessionList = _.cloneDeep(state.srcBaseSessionList)
  }
}

export const actions = {
  /**
   * 발신기반 세션 제어 정책을 추가한다.
   */
  async addSrcBaseSession ({state, dispatch, commit}, {id, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const {code, result} = await this.$axios.$post(`${apiPrefix}/send-session-control/${id}/auth-traffic-control-polices`, params, {loading, successAlert})

      if (code === 'ok') {
        res.result = result

        commit('addSrcBaseSession', result)
        commit('copySrcBaseSessionList')
        dispatch('common/common/setIsChanged', true, {root: true})
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 선택된 발신기반 세션제어 정책을 삭제한다.
   */
  async delSrcBaseSession ({commit, dispatch}, {id, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const {code, result} = await this.$axios.$delete(`${apiPrefix}/send-session-control/${id}/auth-traffic-control-polices`, {
        data: params,
        loading,
        successAlert
      })

      if (code === 'ok') {
        res.result = result

        if (result.errors) {
          res.errors = result.errors
        }

        commit('copySrcBaseSessionList')
        dispatch('common/common/setIsChanged', true, {root: true})
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 발신기반 세션 제어 정책을 수정한다.
   */
  async setSrcBaseSession ({state, commit, dispatch}, {id, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const {code, result} = await this.$axios.$put(`${apiPrefix}/send-session-control/${id}/auth-traffic-control-polices`, params, {loading, successAlert})

      if (code === 'ok') {
        res.result = result

        if (result.msg) {
          res.reason = result.msg
        }

        if (params.items.length === 1) {
          commit('setSrcBaseSession', result)
        }

        commit('copySrcBaseSessionList')
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 발신기반 세션 제어 정책을 조회한다.
   */
  async getSrcBaseSessionList ({commit}, {id, loading = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const {code, result} = await this.$axios.$get(`${apiPrefix}/send-session-control/${id}/auth-traffic-control-polices`, {loading})

      if (code === 'ok') {
        commit('initSrcBaseSessionList', result)
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  }
}
